<template>
  <ModalExporter/>
</template>

<script>
import ModalExporter from "@/components/reporteditor/modals/exporter/ModalExporter.vue"
export default {
    components: { ModalExporter },
}
</script>

<style>

</style>